import React, { createContext, useReducer, useEffect } from "react";
import { withTranslation  } from 'react-i18next';
import { Provider } from "react-redux";
import Login from "./pages/login";
import Router from "./router";
import store from "./store";
import "./App.less";

export const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null
      };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    localStorage.removeItem('furnaceTemp');

    const user = JSON.parse(localStorage.getItem("user") || null);

    if (user) {
      dispatch({
        type: "LOGIN",
        payload: { user }
      });
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Provider store={store}>
        <div className="App">{!state.isAuthenticated ? <Login /> : <Router />}</div>
      </Provider>
    </AuthContext.Provider>
  );
}

export default withTranslation()(App);
